module.exports = __webpack_public_path__ + "static/img/update.c84c918e.png";